import { LogOut } from 'lucide-react';
import { useAdminLogout, useAdminSession } from '../api/admin-queries.js';
import { AdminLoginForm } from '../components/admin/admin-login-form.js';
import { KitProductionTable } from '../components/admin/kit-production-table.js';
import { MessagesPanel } from '../components/admin/messages-panel.js';
import { OperationsPanel } from '../components/admin/operations-panel.js';
import { OrdersTable } from '../components/admin/orders-table.js';
import { PurchaseOrdersPanel } from '../components/admin/purchase-orders-panel.js';
import { ErrorState } from '../components/error-state.js';

export function AdminPage() {
  const session = useAdminSession();
  const logout = useAdminLogout();

  if (session.isError)
    return (
      <ErrorState
        message="No pudimos verificar tu sesión."
        onRetry={() => void session.refetch()}
      />
    );
  if (session.data === undefined) return <p aria-live="polite">Verificando sesión…</p>;
  if (session.data === null) return <AdminLoginForm />;

  return (
    <div className="flex flex-col gap-10">
      <header className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold">Administración</h1>
          <p className="text-muted-foreground">Sesión de {session.data.email}</p>
        </div>
        <button
          type="button"
          onClick={() => {
            logout.mutate();
          }}
          className="inline-flex min-h-11 cursor-pointer items-center gap-2 rounded-control border border-border px-4 font-medium hover:bg-muted"
        >
          <LogOut aria-hidden="true" className="size-4" />
          Cerrar sesión
        </button>
      </header>
      <PurchaseOrdersPanel />
      <MessagesPanel />
      <KitProductionTable />
      <OperationsPanel />
      <OrdersTable />
    </div>
  );
}
